import { h, Component } from 'preact';
import Store from 'store/store';
import Input from 'components/bolt/input/input';
import Button from 'components/bolt/button/button';
import FilterIcon from 'components/bolt/icons/filter';
import EmptyPin from 'components/bolt/icons/emptyPin';

import { debounce, joinClasses, accessNested, toQueryString } from 'utils/utils';
import { replaceWithVNode } from 'utils/vnode';
import parseQueryString from 'utils/parseQueryString';
import { geoSearch, geoSearchOne } from 'utils/bolt/geo';

import s from 'components/bolt/showtimes/locationSearch2.sss';

export default class LocationSearch2 extends Component {

	constructor(props) {
		super(props);
		this.updateCitySuggestions = debounce(this.updateCitySuggestions, 300);
		this.iconClick = this.iconClick.bind(this);
		this.onInput = this.onInput.bind(this);
		this.onMouseDown = this.onMouseDown.bind(this);
		this.onFocus = this.onFocus.bind(this);
		this.onBlur = this.onBlur.bind(this);
		this.onKeyDown = this.onKeyDown.bind(this);
		this.search = this.search.bind(this);
		this.focusHandler = this.focusHandler.bind(this);
		this.loadingClickHandler = this.loadingClickHandler.bind(this);

		this.state.filled = false;
		this.state.citySuggestions = [];
		this.state.highlightedSuggestion = 0;

		this.updateCitySuggestionsId = 0;
		this.fontStyles = {};
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.geo.loading && !this.props.geo.loading) {
			this.setState({ value: '' });
		}
	}

	componentDidMount() {
		if (this.props.autofocus) {
			this.focus();
		}
	}

	transformNearbyLocation(loc) {
		return {
			city: loc.city,
			state: loc.state,
			countryCode: loc.countryCode || loc.country,
			lat: loc.lat,
			lon: loc.lon,
		};
	}

	async updateCitySuggestions() {
		if (!this.$input) {
			return;
		}
		let value = this.$input.value;
		if (!value) {
			return;
		}
		let reqId = ++this.updateCitySuggestionsId;
		let results = [];

		try {
			results = await geoSearch({ search: value });
		} catch (e) {
			console.log('Error getting location search results', e);
		}
		if (reqId !== this.updateCitySuggestionsId) {
			return;
		}
		let citySuggestions = results.slice(0, 10);
		if (this.props.nearbyLocations) {
			let valueLower = value.toLowerCase();
			let extra = this.props.nearbyLocations.filter(
				l => (l.city || '').toLowerCase().includes(valueLower)
			).map(this.transformNearbyLocation);
			citySuggestions = citySuggestions.concat(extra);
		}
		this.setState({
			citySuggestions,
			highlightedSuggestion: 0,
			suggestionsLoading: false
		});
	}

	removeLocationQueryParameter() {
		let qs = parseQueryString();
		if (qs.location) {
			delete qs.location;
			let newUrl = location.pathname + toQueryString(qs) + location.hash;
			history.replaceState({ activePage: Store.get().activePage }, '', newUrl);
		}
	}

	async search() {
		let search = this.$input && this.$input.value;
		if (!search) {
			return;
		}

		if (typeof this.props.onSearch === 'function') {
			this.props.onSearch(search);
		}

		this.removeLocationQueryParameter();
		Store.emit('SET_USER_LOCATION', () => geoSearchOne({ search }), 'search', this.props.ticketType);
		this.reset();
		this.blur();
	}

	select(suggestion) {
		if (!suggestion.city) {
			suggestion.city = suggestion.label;
		}
		if (typeof this.props.onSelect === 'function') {
			this.props.onSelect(suggestion);
		}

		this.removeLocationQueryParameter();
		let type = this.props.nearbyLocations && this.props.nearbyLocations.includes(suggestion) ? 'nearby' : 'suggestion';
		Store.emit('SET_USER_LOCATION', { ...suggestion }, type, this.props.ticketType);
		Store.emit('SHOWTIMES_SEARCH_OVERLAY_HIDE');
		this.reset();
		this.blur();
	}

	reset() {
		if (!this.$input) {
			return;
		}
		this.$input.value = '';
		this.setState({ value: '', filled: false });
	}

	focus() {
		if (this.$input) {
			this.$input.focus();
		}
	}
	blur() {
		if (this.$input) {
			this.$input.blur();
		}
	}

	iconClick() {
		this.reset();
		this.focus();
	}

	onInput() {
		let value = this.$input.value;
		this.setState({ value });

		let filled = !!value;
		if (this.state.filled !== filled) {
			this.setState({ filled });
		}

		if (!this.state.suggestionsLoading) {
			this.setState({ suggestionsLoading: true, highlightedSuggestion: -1 });
		}

		this.updateCitySuggestions();
	}

	onMouseDown() {
		clearTimeout(this.mouseDownTimer);
		this.mouseDown = true;
		this.mouseDownTimer = setTimeout(() => this.mouseDown = false, 16);
	}
	onFocus() {
		if (typeof this.props.onFocus === 'function') {
			this.props.onFocus();
		}
	}
	onBlur() {
		if (!this.props.isMobile && this.mouseDown) {
			return this.focus();
		}
		if (typeof this.props.onBlur === 'function') {
			this.props.onBlur();
		}
	}

	onKeyDown(e) {
		let state = this.state;
		switch (e.key) {
			case 'Down':
			case 'ArrowDown':
				e.preventDefault();
				let nextSelection = state.highlightedSuggestion + 1;
				if (nextSelection >= state.citySuggestions.length) {
					nextSelection = 0;
				}
				this.setState({ highlightedSuggestion: nextSelection });
				break;
			case 'Up':
			case 'ArrowUp':
				e.preventDefault();
				let prevSelection = state.highlightedSuggestion - 1;
				if (prevSelection < 0) {
					prevSelection = state.citySuggestions.length - 1;
				}
				this.setState({ highlightedSuggestion: prevSelection });
				break;
			case 'Enter':
				e.preventDefault();
				let highlighted = state.citySuggestions[state.highlightedSuggestion];
				if (highlighted) {
					this.select(highlighted);
				// } else {
				// 	this.search();
				}
				break;
			case 'Esc':
			case 'Escape':
				e.preventDefault();
				this.reset();
		}
	}

	loadingClickHandler() {
		this.setState({ loadingClicked: true });
	}

	renderSuggestions() {
		const baseCopy = accessNested(Store.get(), 'appData.copy.baseCopy');
		let state = this.state;
		if (state.suggestionsLoading && state.filled) {
			return (
				<div class={s.suggestionsLoading} key="loading" onMouseDown={this.loadingClickHandler}>
					<div class={s.loadingIcon} />
					<div class={s.loadingCopy}>
						{baseCopy.$LOADING_SEARCH_SUGGESTIONS || 'Loading...'}
					</div>
				</div>
			);
		}

		// Should we show filters suggestions (e.g. 3D) through the location search like before ?
		let suggestions = state.filled ? state.citySuggestions : [];
		if (!state.filled && this.props.nearbyLocations) {
			suggestions = suggestions.concat(this.props.nearbyLocations.map(this.transformNearbyLocation));
		}

		if (!suggestions.length && this.props.mobileOverlayActive) {
			return <div class={s.noSuggestions} key="empty">{baseCopy.$NO_SEARCH_SUGGESTIONS || 'No suggestions'}</div>;
		}
		// let currentCountry = accessNested(this.props, 'geo.countryCode');
		return suggestions.map((suggestion, i) => {
			let highlight = () => this.setState({ highlightedSuggestion: i });
			let key = [suggestion.countryCode, suggestion.city, suggestion.state, suggestion.countryCode, suggestion.label].filter(e => e).join();
			// let details = [
			// 	suggestion.countryCode === 'us' && suggestion.state,
			// 	suggestion.countryCode !== currentCountry && suggestion.countryCode
			// ].filter(e => e).join(', ');
			// let content = [
			// 	<span key="city">{suggestion.city}</span>,
			// 	<span key="details" class={s.suggestionDetails}>{details ? ', ' + details : ''}</span>
			// ];
			let label = suggestion.label;
			if (!label) {
				label = [
					suggestion.city,
					suggestion.countryCode === 'US' && suggestion.state,
					// suggestion.countryCode !== currentCountry && suggestion.countryCode
					suggestion.countryCode
				].filter(e => e).join(', ');
			}
			let content = replaceWithVNode(<span>{label}</span>, suggestion.city, <strong>{suggestion.city}</strong>);
			return (
				<Button
					class={joinClasses({ s, suggestion: true, highlighted: i === state.highlightedSuggestion })}
					key={key}
					trigger={() => this.select(suggestion)}
					onMouseEnter={highlight}
					// onFocus={highlight}
					// We make them selectable using arrows, don't need to be tab-selectable
					tabIndex="-1"
				>
					<span class={s.pinSpan}><EmptyPin class={joinClasses(s.suggestionIcon, s.emptyPin)} /></span>
					{content}
				</Button>
			);
		});
	}

	renderPlaceholder() {
		let geo = this.props.geo;
		const { value } = this.state;
		const searchPlaceholderCopy = accessNested(Store.get(), 'appData.copy.baseCopy.$SEARCH_PLACEHOLDER');

		if (!geo) {
			return <div class={s.placeholder} />;
		}
		if (geo.loading) {
			return (
				<div class={s.placeholder}>
					<span class={s.extra}>{value}</span>
					<span class={s.extra}>{searchPlaceholderCopy || 'showtimes'}</span>
				</div>
			);
		}
		if (!geo.city) {
			return <div class={s.placeholder} />;
		}

		return (
			<div class={s.placeholder}>
				<span class={s.name}>{geo.city}</span>
				<span class={s.extra}>{searchPlaceholderCopy || 'showtimes'}</span>
			</div>
		);
	}

	focusHandler() {
		if (this.props.mobileOverlayActive) {
			return;
		}

		this.setState({ mobileOverlayActive: true });

		Store.emit('SET_HEADER_ACTION', {
			icon: 'back',
			action: () => this.setState({ mobileOverlayActive: false })
		});
	}

	render(props) {
		let state = this.state;
		let filled = state.filled;
		const filtersNum = Object.values(props.selectedFilters).filter(v => v?.length).length - 1;
		const geoLoading = this.props.geo.loading;
		const { mobileOverlayActive } = this.props;
		const store = Store.get();
		this.fontStyles = accessNested(store, 'appData.styling.fontVariables');
		const isRTL = this.fontStyles.textDirection === 'rtl';
		const accessibilityCopy = accessNested(store, 'appData.copy.accessibilityCopy', {});
		const searchPlaceholderCopy = accessNested(store, 'appData.copy.baseCopy.$SEARCH', 'Search');

		const iconAriaLabel = filled ? accessibilityCopy.$CLEAR_SEARCH_ARIA : accessibilityCopy.$SEARCH_MAG_GLASS_ARIA;

		const filtersCopy = accessNested(store, 'appData.copy.baseCopy.$FILTERS') || 'Filters';

		const locationInput = (
			<Input
				disabled={props.disabled}
				ref={e => this.$input = e}
				containerClass={joinClasses(
					props.class,
					this.fontStyles.showtimesSearch,
					{
						s, container: true,
						filled,
						geoLoading
					}
				)}
				class={s.input}
				placeholder={searchPlaceholderCopy}
				inputStyle={this.fontStyles.showtimesSearch}
				onInput={this.onInput}
				onFocus={this.onFocus}
				onBlur={this.onBlur}
				onKeyDown={this.onKeyDown}
				onMouseDown={this.onMouseDown}
				ariaLabel={accessibilityCopy[props.showtimesAppData.searchInputAriaLabel] || props.showtimesAppData.searchInputAriaLabel || 'Search location'}
				role="search"
			>
				{this.renderPlaceholder()}
				<Button class={joinClasses(s.icon, isRTL && s.rtlIcon)} trigger={this.iconClick} tabIndex={filled ? 0 : -1} ariaLabel={iconAriaLabel} />
				<div className={joinClasses(s.filtersNum, filtersNum > 0 && s.active)}>
					{filtersNum}
				</div>
				<Button
					class={joinClasses(s.filtersIcon)}
					onMouseDown={(e) => {
						e.preventDefault();
						e.stopPropagation();
						e.stopImmediatePropagation();
					}} trigger={(e) => {
						e.preventDefault();
						e.stopPropagation();
						e.stopImmediatePropagation();
						this.props.showFilterSelection(e);
					}}
				>
					<span>{filtersCopy}</span>
					<FilterIcon />
				</Button>
				{!mobileOverlayActive && (
					<div class={s.suggestions}>
						{this.renderSuggestions()}
					</div>
				)}
			</Input>
		);

		if (mobileOverlayActive) {
			return (
				<div class={s.mobileOverlay}>
					<div class={joinClasses({ s, overlayHeader: true, filled: this.state.filled })}>
						{locationInput}
					</div>
					<div class={joinClasses(s.filled, s.scrollable)}>
						<div class={s.suggestions} body-scroll-lock-ignore>
							{this.renderSuggestions()}
						</div>
					</div>
				</div>
			);
		}
		return locationInput;
	}

}
